import { Mobile, Header_CoreInit, Carousel_CoreInit } from './core'
import Landing from './modules/landing'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './plugins/rolling-banner'
import './plugins/scroll-to-anchor'
import './plugins/curved-box'
import './plugins/vegetable-menu'
import './plugins/sticky-images'
import './plugins/horizontal-veggies'

gsap.registerPlugin(ScrollTrigger)

Header_CoreInit({
  scrolling_offset: 400,
  burger_options: {
    onToggle: function() {
      $('body').toggleClass('--menu-open')
      $('body').removeClass('--contact-open')
    },
  }
})

Carousel_CoreInit([
  {
    classSelector: 'carousel--postitem__vegetable',
    swiperOptions: {
      simulateTouch: window.innerWidth < 768,
    },
  },
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  var new_header = $('header').clone().addClass('--desktop-only --cloned');
  new_header.find('.rolling-banner').remove();
  new_header.find('.contact-pull-out').remove();
  new_header.insertAfter('header');

  $('.--contact').click(function() {
    $('body').toggleClass('--contact-open')
  })

  $('.btn-primary, .social-icons__item a').each(function() {
    $(this).wrapInner('<span/>');
  })

  $('.js-close-contact').click(function() {
    $('body').removeClass('--contact-open')
  })

  $('.grid--style--sticky-image').each(function() {
    $(this).StickyImages();
  })

  Landing.init()

  $('.js-rolling-banner').each(function() {
    $(this).RollingBanner()
  })

  $('.pull-up').each(function() {
    $(this).prev('.splash').addClass('--offset-title')
  })

  $('.vegetable-menu').each(function() {
    $(this).VegetableMenu()
  })

  $('.js-vegetable-rolling-banner').each(function() {
    $(this).RollingBanner(80)
  })

  $('a[href^=#]').each(function() {
    $(this).scrollToAnchor()
  })

  $('.boxed-container').each(function(index, value) {
    $(this).CurvedBox('clip' + index)
  })

  $('.carousel--postitem__vegetable').each(function(index, value) {
    $(this).HorizontalVeggies()
  })

  if ($('html').hasClass('no-webp')) {
    $('img[src*=".png.webp"]').each(function() {
      $(this).attr('src', $(this).attr('src').replace('.png.webp', '.png'))
    })
  }

  /* make videos look like images */
  $('.video-loop').each(function() {
    let self = $(this)
    let video = $(this).find('video')
    if (video.data('loaded')) {
      setTimeout(function() {
        picture(video.get(0))
        video.get(0).play()
      }, 60)
    } else {
      video.on('canplaythrough', function() {
        picture(video.get(0))
        video.get(0).play()
      })
    }
  })

  $('.full-screen-row:last-child, .boxed').each(function() {
    var color = $(this).closest('.page-section').next('.page-section').css('background-color');
    $(this).css('--next-section-color', color);
  })

  // Full Screen media
  const section = document.querySelector('.full-screen-media');
  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'center center',
      end: '+=500',
      scrub: true,
      pin: true,
      anticipatePin: 1,
    }
  })
  gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'center center',
      end: '+=9999999',
      toggleClass: 'scaling'
    }
  })

  if ($('.section__sun__wrapper img').length > 0) {
    //Rotate yellow sun
    let rotateSun = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".section__sun__wrapper img",
          start: "top center",
          end: "bottom+=1000 top",
          invalidateOnRefresh: true
        }
      })
      .fromTo(".section__sun__wrapper img",{
          scale: 1,
        },{
          scale: 1.1,
          duration: 2,
          ease: "power1.out"
        })
      .fromTo(".section__sun__wrapper img",{
          rotation: 0
        },{
          rotation: 90,
          duration: 2,
          repeat: 1,
          ease: "linear"
        },0)
      .fromTo(".section__sun__wrapper img",{
          rotation: 90,
        },{
          rotation: 450,
          duration: 10,
          repeat: -1,
          delay: 2,
          ease: "linear"
        },0)
      .timeScale(1);
  }

  const sticky_image = document.querySelectorAll(".grid--style--sticky-image");
  sticky_image.forEach((sticky_image) => {
    ScrollTrigger.create({
      trigger: sticky_image,
      start: "top bottom", // when the top of the section hits the center of the viewport
      //end: "bottom bottom", // when the bottom of the section hits the center of the viewport
      toggleClass: "--animate-active",
    });
  });
})

$(window).on("resize orientationchange load", function() {
  $('.full-screen-media').each(function() {
    $(this).find('.full-screen-media__container').css('--scale', ($(window).width() + 32) / $(this).closest('.full-screen-media__width-ruler').width())
  })

  /* Footer pop out */
  $(window).on("scroll", function() {
    var scrollPosition = $(window).scrollTop() + $(window).height();
    var bodyHeight = $('body').height()
    if (scrollPosition > bodyHeight - 100) {
      $('.footer').addClass('--animate-active')
    } else {
      $('.footer').removeClass('--animate-active')
    }
  });
});
